
import React from 'react';
import { Button } from '@/components/ui/button';
import { IndustryType } from '@/data/industryData';

interface IndustrySelectorProps {
  industry: IndustryType;
  setIndustry: (industry: IndustryType) => void;
}

const IndustrySelector: React.FC<IndustrySelectorProps> = ({ industry, setIndustry }) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mb-4">
      <Button
        variant={industry === "restauration" ? "default" : "outline"}
        size="sm"
        className={industry === "restauration" ? "bg-slate-700 hover:bg-slate-800" : "border-slate-300 text-slate-700"}
        onClick={() => setIndustry("restauration")}
      >
        Restauration
      </Button>
      <Button
        variant={industry === "divertissement" ? "default" : "outline"}
        size="sm"
        className={industry === "divertissement" ? "bg-slate-700 hover:bg-slate-800" : "border-slate-300 text-slate-700"}
        onClick={() => setIndustry("divertissement")}
      >
        Divertissement
      </Button>
      <Button
        variant={industry === "hotellerie" ? "default" : "outline"}
        size="sm"
        className={industry === "hotellerie" ? "bg-slate-700 hover:bg-slate-800" : "border-slate-300 text-slate-700"}
        onClick={() => setIndustry("hotellerie")}
      >
        Hôtellerie
      </Button>
      <Button
        variant={industry === "sante" ? "default" : "outline"}
        size="sm"
        className={industry === "sante" ? "bg-slate-700 hover:bg-slate-800" : "border-slate-300 text-slate-700"}
        onClick={() => setIndustry("sante")}
      >
        Santé et Beauté
      </Button>
      <Button
        variant={industry === "automobile" ? "default" : "outline"}
        size="sm"
        className={industry === "automobile" ? "bg-slate-700 hover:bg-slate-800" : "border-slate-300 text-slate-700"}
        onClick={() => setIndustry("automobile")}
      >
        Automobile
      </Button>
    </div>
  );
};

export default IndustrySelector;
